var map = {
	"./4theplayer.svg": "e73f",
	"./about-us-bg.png": "c088",
	"./about-us-bg_768.png": "971e",
	"./about-us-bg_960.png": "59e3",
	"./animatedLoader.gif": "5ae3",
	"./app-check.svg": "97a7",
	"./app-five-full-star.svg": "5be0",
	"./app-four-full-star.svg": "67a2",
	"./app-icon-copy.svg": "5fd1",
	"./app-landing-awesome-bg-small.png": "48cd",
	"./app-landing-awesome.png": "e5e8",
	"./app-logo.svg": "2405",
	"./arrow-right.svg": "3f8a",
	"./arrow.svg": "1106",
	"./astropay.png": "4547",
	"./astropay.svg": "b7fc",
	"./august-promotions.png": "0d1d",
	"./august_1248.png": "3fc4",
	"./august_1248_page.png": "0968",
	"./august_1920.png": "28ab",
	"./august_320.png": "edf3",
	"./august_460.png": "8b05",
	"./august_600.png": "1405",
	"./august_900.png": "65f6",
	"./august_900_page.png": "c2fe",
	"./auth-banner.png": "5cc5",
	"./auth-bg.png": "db56",
	"./auth-bg1-large.png": "9acf",
	"./auth-bg1.png": "1a9c",
	"./auth-chat.svg": "3d75",
	"./aztec_1248.png": "7821",
	"./aztec_1920.png": "e141",
	"./aztec_320.png": "5088",
	"./aztec_460.png": "a48b",
	"./aztec_600.png": "a695",
	"./aztec_900.png": "1bbb",
	"./banker-gold-page_1248.png": "9a43",
	"./banker-gold-page_900.png": "e095",
	"./banker-gold-promotions.png": "b2c9",
	"./banker-gold_1248.png": "7efd",
	"./banker-gold_1920.png": "11d5",
	"./banker-gold_320.png": "4e2f",
	"./banker-gold_460.png": "b5d6",
	"./banker-gold_600.png": "b684",
	"./banker-gold_900.png": "485a7",
	"./banker-green-page_1248.png": "213a",
	"./banker-green-page_900.png": "69e6",
	"./banker-green-promotions.png": "57c4",
	"./banker-green_1248.png": "549a",
	"./banker-green_1920.png": "d05b",
	"./banker-green_320.png": "6340",
	"./banker-green_460.png": "0142",
	"./banker-green_600.png": "e680",
	"./banker-green_900.png": "b5dc",
	"./banker-purple-page_1248.png": "a04d",
	"./banker-purple-page_900.png": "172c",
	"./banker-purple-promotions.png": "edb7",
	"./banker-purple_1248.png": "add6",
	"./banker-purple_1920.png": "758d",
	"./banker-purple_320.png": "df49",
	"./banker-purple_460.png": "d6b5",
	"./banker-purple_600.png": "b630",
	"./banker-purple_900.png": "6180f",
	"./banner1_1248.png": "42f2",
	"./banner1_1920.png": "0844",
	"./banner1_460.png": "14df",
	"./banner1_768.png": "459a",
	"./banner1_960.png": "a719",
	"./belatra.svg": "31ba",
	"./bgaming.svg": "acf1",
	"./bigtimegaming.svg": "82ba",
	"./bitcoin.svg": "ef76",
	"./bitcoin1.png": "dc85",
	"./bitcoin2.png": "5d20",
	"./bitcoin3.png": "91ed",
	"./bitcoin4.png": "f603",
	"./bitcoin5.png": "577d",
	"./bonus-badge.png": "6a27",
	"./bonus-ball.png": "1a1c",
	"./bonus-cup.png": "7e45",
	"./bonus-diamond.png": "0ad5",
	"./bonus-spades.png": "e033",
	"./bonus-weekend.png": "ec2e",
	"./bonus.png": "ef09",
	"./bonus.svg": "baa7",
	"./book_1248.png": "194c",
	"./book_1920.png": "b7f9",
	"./book_320.png": "d4d8",
	"./book_460.png": "5db9",
	"./book_600.png": "de09",
	"./book_900.png": "742b",
	"./booming.svg": "c510",
	"./boominggames.svg": "7b12",
	"./booongo.svg": "32e7",
	"./caishen_1248.png": "8dc2",
	"./caishen_1920.png": "19ba",
	"./caishen_320.png": "8deb",
	"./caishen_460.png": "7e10",
	"./caishen_600.png": "31fc",
	"./caishen_900.png": "e8a0",
	"./card1.png": "ceb3",
	"./card2.png": "64e6",
	"./card3.png": "fb8c",
	"./cards.svg": "ab42",
	"./cashback.svg": "afef",
	"./cashback_1248.png": "421c",
	"./cashback_1632.png": "170a",
	"./cashback_768.png": "3698",
	"./cashback_960.png": "f00f",
	"./cashout.svg": "f57a",
	"./categories_nav.svg": "295e",
	"./chair.png": "77e3",
	"./chat.svg": "9e5a",
	"./check-app.svg": "e8f4",
	"./check.svg": "6aa8",
	"./circle-min.png": "9ec4",
	"./circle.png": "d215",
	"./circle.svg": "869e",
	"./clock.svg": "6e22",
	"./close-app.svg": "eeb6",
	"./coinspaid.svg": "60f1",
	"./cs.png": "9943",
	"./cs.svg": "9f8e",
	"./curacao.svg": "b490",
	"./daily-tournament-bg_1248.png": "a6d4",
	"./daily-tournament-bg_1920.png": "0883",
	"./daily-tournament-bg_460.png": "653d",
	"./daily-tournament-bg_768.png": "4235",
	"./daily-tournament-bg_960.png": "80fa",
	"./de.png": "19c2",
	"./de.svg": "2598",
	"./dealer.png": "d115",
	"./demigods-page_1248.png": "0101",
	"./demigods-page_900.png": "7df3",
	"./demigods-promotions.png": "bc44",
	"./demigods_1248.png": "4654",
	"./demigods_1920.png": "c5e4",
	"./demigods_320.png": "525b",
	"./demigods_460.png": "a8e1",
	"./demigods_600.png": "ee7a",
	"./demigods_900.png": "689e",
	"./derby-promotions.png": "c99c",
	"./derby_1248.png": "8efa",
	"./derby_1920.png": "e7fb",
	"./derby_320.png": "109d",
	"./derby_460.png": "f697",
	"./derby_600.png": "0f65",
	"./derby_900.png": "0b2f",
	"./dice.png": "fa88",
	"./dice.svg": "429d",
	"./dotted-border.png": "65a6",
	"./download-app.svg": "0629",
	"./download-image-320.svg": "f7e4",
	"./download-image.svg": "3ad8",
	"./download.svg": "9f0f",
	"./drops-wins.png": "0008",
	"./drops-wins_460.png": "21fd",
	"./dropsBanner_1248.png": "f28e",
	"./dropsBanner_1920.png": "f332",
	"./dropsBanner_320.png": "9cf8",
	"./dropsBanner_460.png": "e0ee",
	"./dropsBanner_600.png": "03cc",
	"./dropsBanner_900.png": "f314",
	"./dropsLive-promotion.png": "f45e",
	"./dropsLive_1248.png": "21b4",
	"./dropsLive_1920.png": "32bb",
	"./dropsLive_320.png": "bc40",
	"./dropsLive_460.png": "0508",
	"./dropsLive_600.png": "344b",
	"./dropsLive_900.png": "f0b3",
	"./dropsSlots-promotion.png": "7232",
	"./dropsSlots_1248.png": "6140",
	"./dropsSlots_1920.png": "3d36",
	"./dropsSlots_320.png": "e54e",
	"./dropsSlots_460.png": "de4c",
	"./dropsSlots_600.png": "6dda",
	"./dropsSlots_900.png": "b146",
	"./drops_1248.png": "56e0",
	"./drops_320.png": "ca91",
	"./drops_460.png": "1cd8",
	"./drops_600.png": "7e3f",
	"./drops_624.png": "54ce",
	"./drops_900.png": "53b4",
	"./ecashout.svg": "4414",
	"./egt.svg": "a739",
	"./electricelephant.svg": "6ee2",
	"./en-ca.svg": "9f57",
	"./en.png": "17b5",
	"./en.svg": "38e4",
	"./endorphina.svg": "d2af",
	"./eng.png": "47a1",
	"./evolution.svg": "5a36",
	"./ezeewallet.svg": "32df",
	"./fantasmagames.svg": "9d91",
	"./fast.svg": "2476",
	"./five-full-star.svg": "6637",
	"./flexepin.png": "2329",
	"./flower.svg": "1c80",
	"./football-promotions.png": "ec8c",
	"./footballBanner_1248.png": "5680",
	"./footballBanner_1920.png": "5360",
	"./footballBanner_320.png": "8667",
	"./footballBanner_460.png": "f505",
	"./footballBanner_600.png": "399a",
	"./footballBanner_900.png": "1c36",
	"./football_460.png": "9c34",
	"./football_600.png": "96c1",
	"./footer-bg.svg": "1593",
	"./footer-image.png": "a9b0",
	"./footer-image_320.png": "ed08",
	"./footer-text.png": "9231",
	"./footer-text_1400.png": "9099",
	"./footer-text_320.png": "d639",
	"./footer-text_460.png": "635b",
	"./footer-text_600.png": "c6a2",
	"./footer-text_767.png": "eede",
	"./footer-text_900.png": "2220",
	"./four-full-star.svg": "af9c",
	"./fr.svg": "40b7",
	"./fr_ca.svg": "f172",
	"./game1.png": "d6f3",
	"./game2.png": "b459",
	"./game3.png": "8c09",
	"./game4.png": "4728",
	"./game5.png": "1809",
	"./game6.png": "cfa9",
	"./game7.png": "4a94",
	"./game8.png": "5505",
	"./game9.png": "13e6",
	"./gameart.svg": "ccd0",
	"./games.svg": "ccdb",
	"./gaming_book.svg": "dca9",
	"./go.svg": "58a6",
	"./gr.svg": "9afd",
	"./guru.svg": "c6ec",
	"./habanero.svg": "d4d9",
	"./hero-bg-joker_mobile.jpg": "5fc6",
	"./hero-bg.jpg": "9f0b",
	"./highroller_1248.png": "b31f",
	"./highroller_1920.png": "5216",
	"./highroller_320.png": "140b",
	"./highroller_460.png": "e2f3",
	"./highroller_600.png": "d350",
	"./highroller_900.png": "530d",
	"./ic_close.svg": "e72c",
	"./icons.svg": "48a6",
	"./idebit.svg": "4a0b",
	"./igtech.svg": "9e79",
	"./inpay.png": "bf95",
	"./instadebit.svg": "5036",
	"./instanteft.png": "d658",
	"./interac-etransfer.svg": "1a3e",
	"./interac-online.svg": "569f",
	"./interac_35.png": "42d3",
	"./jackpot-bg_1248.png": "f569",
	"./jackpot-bg_1920.png": "bec8",
	"./jackpot-bg_460.png": "9e58",
	"./jackpot-bg_768.png": "af0d",
	"./jackpot-bg_960.png": "b81a",
	"./jeton-logo.svg": "ec5c",
	"./joker_1248.png": "2970",
	"./joker_1920.png": "c671",
	"./joker_320.png": "c20e",
	"./joker_460.png": "b6d5",
	"./joker_600.png": "dc01",
	"./joker_900.png": "9780",
	"./joker_sad.png": "2474",
	"./kalamba.svg": "1e38",
	"./klarna.svg": "372a",
	"./level-min.png": "a8e0",
	"./level.png": "9fa0",
	"./license.png": "b48e",
	"./lobby_nav.svg": "8dcb",
	"./locked-bonus.svg": "c850",
	"./logo-footer.svg": "7a30",
	"./logo.svg": "1ae4",
	"./lottery_1248.png": "12e8",
	"./lottery_320.png": "f945",
	"./lottery_460.png": "9bf6",
	"./lottery_600.png": "681a",
	"./lottery_768.png": "c114",
	"./lottery_960.png": "e7d4",
	"./lucky-page_1248.png": "60b1",
	"./lucky-page_900.png": "34cc",
	"./lucky-promotions.png": "4e5c",
	"./lucky_1248.png": "9c64",
	"./lucky_1920.png": "af3a",
	"./lucky_320.png": "3ecb",
	"./lucky_460.png": "0c32",
	"./lucky_600.png": "6c2d",
	"./lucky_900.png": "bd1a",
	"./lvl1.png": "a1a4",
	"./lvl10.png": "e6f7",
	"./lvl2.png": "e36a",
	"./lvl3.png": "8a21",
	"./lvl4.png": "594c",
	"./lvl5.png": "d4d5",
	"./lvl6.png": "35c2",
	"./lvl7.png": "e1b4",
	"./lvl8.png": "4cf8",
	"./lvl9.png": "3735",
	"./madnessBanner_1248.png": "fc34",
	"./madnessBanner_1920.png": "bfe0",
	"./madnessBanner_320.png": "6fa4",
	"./madnessBanner_460.png": "471b",
	"./madnessBanner_600.png": "c22e",
	"./madnessBanner_900.png": "73d0",
	"./madness_1248.png": "483e",
	"./madness_460.png": "5fc5",
	"./madness_600.png": "aeee",
	"./madness_900.png": "5ab2",
	"./maestro.svg": "f29d",
	"./mastercard.svg": "29b8",
	"./maxwingaming.svg": "73a7",
	"./mayBanner_1248.png": "70dd",
	"./mayBanner_1920.png": "3282",
	"./mayBanner_320.png": "9cf5",
	"./mayBanner_460.png": "a4a2",
	"./mayBanner_600.png": "8ac6",
	"./mayBanner_900.png": "a677",
	"./mayBanner_900_ols.png": "16ec",
	"./may_1248.png": "6a67",
	"./may_320.png": "d54d",
	"./may_460.png": "1136",
	"./may_600.png": "c4e7",
	"./may_900.png": "0019",
	"./mga.svg": "0f33",
	"./microgaming-white.svg": "0213",
	"./microgaming.svg": "79f4",
	"./muchbetter.png": "4d66",
	"./muchbetter.svg": "1bbc",
	"./neosurf.png": "56df",
	"./neosurf.svg": "22c4",
	"./neteller.svg": "c604",
	"./netent-white.svg": "35cc",
	"./netent.svg": "dde0",
	"./new-tournaments-320.png": "22bf",
	"./new-tournaments.png": "0dd3",
	"./northernlights.svg": "12a0",
	"./not-found.png": "79d9",
	"./notfound-bg.png": "affb",
	"./notfound_bg.png": "70eb",
	"./notification.png": "0920",
	"./nz.svg": "fba0",
	"./offer-bonus.svg": "8c5c",
	"./offer-games.svg": "e77a",
	"./offer-jackpots.svg": "1950",
	"./offer-live.svg": "2f00",
	"./offer-payment.svg": "7d20",
	"./offer-support.svg": "a34f",
	"./payguru.png": "1fb0",
	"./paysafe.svg": "91bd",
	"./platipus.svg": "0b59",
	"./playngo-white.svg": "d64a",
	"./playngo.svg": "1c35",
	"./playson.svg": "fff2",
	"./pragmatic-white.svg": "5403",
	"./pragmatic.svg": "f403",
	"./pragmaticlive.svg": "2310",
	"./promotion1.png": "2a8f",
	"./promotion2.png": "df76",
	"./promotion3.png": "863b",
	"./promotion4.png": "3e3d",
	"./promotion5.png": "c3c8",
	"./promotion6.png": "89df",
	"./promotion7.png": "627b",
	"./promotions-bg-1248.png": "5a6a",
	"./promotions-cashback.png": "746b",
	"./promotions-highroller.png": "3875",
	"./promotions-madness.png": "f455",
	"./promotions-may.png": "3fab",
	"./promotions_nav.svg": "0aad",
	"./providers.svg": "737e",
	"./pushgaming.svg": "07dd",
	"./qr-app.svg": "a701",
	"./qr-code.png": "3ac7",
	"./qr.png": "2103",
	"./qrcode-app.svg": "83b9",
	"./qrcode.svg": "f146",
	"./quickspin.svg": "3476",
	"./race-page_1248.png": "cc88",
	"./race-page_900.png": "af9d",
	"./race-promotions.png": "1a2b",
	"./race_1248.png": "da7a",
	"./race_1920.png": "a275",
	"./race_320.png": "dfaf",
	"./race_460.png": "e4fd",
	"./race_600.png": "233f",
	"./race_900.png": "f812",
	"./registration_success.png": "6a94",
	"./relaxgaming.svg": "5d0a",
	"./scuba-promotion.png": "0505",
	"./scuba_1248.png": "4d16",
	"./scuba_1920.png": "a16c",
	"./scuba_320.png": "6f50",
	"./scuba_460.png": "c8b2",
	"./scuba_600.png": "1aac",
	"./scuba_900.png": "52f9",
	"./settings-app.svg": "fbb4",
	"./settings.svg": "1354",
	"./shield-app.svg": "8bcc",
	"./shield.svg": "7471",
	"./skrill.png": "68af",
	"./skrill.svg": "306f",
	"./sofort.svg": "fb77",
	"./spinomenal.svg": "d65d",
	"./spins-promotions.png": "f68d",
	"./spins_1248.png": "a93e",
	"./spins_1920.png": "489b",
	"./spins_320.png": "fcd0",
	"./spins_460.png": "b837",
	"./spins_600.png": "2466",
	"./spins_900.png": "7329",
	"./spins_page_1248.png": "397c",
	"./spins_page_900.png": "ab4f",
	"./spirit-promotions.png": "48ec",
	"./spirit_1248.png": "afe2",
	"./spirit_1920.png": "a6ba",
	"./spirit_320.png": "0064",
	"./spirit_460.png": "a0df",
	"./spirit_600.png": "426a",
	"./spirit_900.png": "12b6",
	"./star-circle.svg": "4739",
	"./step1.svg": "7910",
	"./step2.svg": "ffee",
	"./step3.svg": "21f9",
	"./sthlmgaming.svg": "ac1f",
	"./sumdes-page_1248.png": "b7e0",
	"./sumdes-page_900.png": "954f",
	"./sumdes-promotions.png": "cd2e",
	"./sumdes_1248.png": "330a",
	"./sumdes_1920.png": "6774",
	"./sumdes_320.png": "78e9",
	"./sumdes_460.png": "e116",
	"./sumdes_600.png": "104c",
	"./sumdes_900.png": "4425",
	"./sunshine-page_1248.png": "371c",
	"./sunshine-page_320.png": "5236",
	"./sunshine-page_460.png": "edfc",
	"./sunshine-page_600.png": "9ce2",
	"./sunshine-page_900.png": "89bf",
	"./sunshine-promo.png": "2226",
	"./sunshine_1248.png": "48c9",
	"./sunshine_1920.png": "f6a3",
	"./sunshine_320.png": "ff46",
	"./sunshine_460.png": "6af7",
	"./sunshine_600.png": "7f96",
	"./sunshine_900.png": "b624",
	"./support.svg": "f0c8",
	"./table.svg": "26c6",
	"./tesla-promotion.png": "4321",
	"./tesla_1248.png": "4e48",
	"./tesla_1920.png": "c1b1",
	"./tesla_320.png": "5449",
	"./tesla_460.png": "146d",
	"./tesla_600.png": "d90d",
	"./tesla_900.png": "48c1",
	"./thunderkick.svg": "9922",
	"./ticket.svg": "6485",
	"./tickets-bg-mobile.png": "1a5c",
	"./tickets-bg.png": "5820",
	"./toggle.svg": "0b0e",
	"./tournament-bg_1248.png": "1a18",
	"./tournament-bg_1920.png": "ea3e",
	"./tournament-bg_460.png": "7ea2",
	"./tournament-bg_768.png": "2ba5",
	"./tournament-bg_960.png": "8fe6",
	"./tournament-circle_nav.svg": "516b",
	"./tournament_nav.svg": "8ede",
	"./tournaments_1248.png": "8f59",
	"./tournaments_1920.png": "800b",
	"./tournaments_320.png": "b57e",
	"./tournaments_460.png": "de8f",
	"./tournaments_600.png": "0cee",
	"./tournaments_900.png": "daa3",
	"./truelab.svg": "54b9",
	"./user-profile.svg": "ba02",
	"./user.svg": "f41a",
	"./vip-bg-1248.png": "2032",
	"./visa.svg": "6180",
	"./visawhite.svg": "2372",
	"./volt.svg": "30a6",
	"./wazdan.svg": "d722",
	"./webmoney.svg": "a903",
	"./wheels.png": "53a0",
	"./wirecard.svg": "272d",
	"./wolf_1248.png": "2219",
	"./wolf_1920.png": "ed5c",
	"./wolf_320.png": "e6fd",
	"./wolf_460.png": "728b",
	"./wolf_600.png": "8645",
	"./wolf_900.png": "484a",
	"./zimpler.svg": "03de",
	"./zoomIn.svg": "e30d",
	"./zoomOut.svg": "86fd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";